import { gql } from 'apollo-angular';
import { dashboardItemFragment, dashboardViewerCanFragment } from '../dashboard/dashboard.fragments';
import { eventCardItemFragment } from '../event-card/event-card.fragments';
import { goalCardItemFragment } from '../goal-card/goal-card.fragments';
import { parentDomainMinimalFragment } from '../parent-domain/parent-domain.fragments';
import { subDomainMinimalFragment } from '../sub-domain/sub-domain.fragments';
import { cardTaskDetailFragment } from '../task/task.fragments';
import { workspaceRoleFragment } from '../workspace-role/workspace-role.fragments';
import { workspaceDetailFragment, workspaceItemFragment, workspaceViewerCanFragment } from './workspace.fragments';

export const workspaceDetailQuery = gql`
  query WorkspaceDetailQuery($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        ...WorkspaceDetailFragment
      }
    }
  }
  ${workspaceDetailFragment}
`;

export const workspaceWithSecondaryDashboardsQuery = gql`
  query WorkspaceWithSecondaryDashboardsQuery($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        ...WorkspaceDetailFragment

        secondaryDashboards {
          nodes {
            id
            title
          }
        }
      }
    }
  }
  ${workspaceDetailFragment}
`;

export const workspaceScopeForRoleModalQuery = gql`
  query WorkspaceScopeForRoleModalQuery($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        id
        title
        dashboard {
          id
          title
          ...DashboardViewerCanFragment
          workspaces {
            nodes {
              id
              title
              ...WorkspaceViewerCanFragment
            }
          }
        }
      }
    }
  }
  ${dashboardViewerCanFragment}
  ${workspaceViewerCanFragment}
`;

export const workspaceWithRolesQuery = gql`
  query WorkspaceWithRolesQuery($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        ...WorkspaceDetailFragment

        dashboard {
          id
          hasMultipleWorkspaces
        }

        workspaceRoles {
          edges {
            node {
              ...WorkspaceRoleFragment
            }
          }
        }
      }
    }
  }
  ${workspaceDetailFragment}
  ${workspaceRoleFragment}
`;

export const workspaceDomainsMenuItemsQuery = gql`
  query WorkspaceDomainsMenuItemsQuery($id: ID!, $filter: WorkspaceFilter) {
    node(id: $id) {
      ... on Workspace {
        ...WorkspaceItemFragment
        ...WorkspaceViewerCanFragment

        dashboard {
          ...DashboardItemFragment

          dashboardFormat {
            id
            shortName

            parentDomains {
              nodes {
                ...ParentDomainMinimal

                subDomains {
                  nodes {
                    ...SubDomainMinimal

                    workspaces(filter: $filter) {
                      edges {
                        mostSevereSeverity
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${dashboardItemFragment}
  ${parentDomainMinimalFragment}
  ${subDomainMinimalFragment}
  ${workspaceViewerCanFragment}
  ${workspaceItemFragment}
`;

export const workspaceDomainsQuery = gql`
  query WorkspaceDomainsQuery($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        id
        dashboard {
          ...DashboardItemFragment

          dashboardFormat {
            id
            shortName

            parentDomains {
              nodes {
                ...ParentDomainMinimal
              }
            }
          }
        }
      }
    }
  }
  ${dashboardItemFragment}
  ${parentDomainMinimalFragment}
`;

export const workspaceWithActiveCardsQuery = gql`
  query WorkspaceWithActiveCards($workspaceId: ID!) {
    node(id: $workspaceId) {
      ... on Workspace {
        id

        goalCards {
          nodes {
            ...GoalCardItemFragment

            workspace {
              id
            }

            cardTasks {
              nodes {
                ...CardTaskDetail
              }
            }
          }
        }

        eventCards {
          nodes {
            ...EventCardItemFragment

            workspace {
              id
            }

            cardTasks {
              nodes {
                ...CardTaskDetail
              }
            }
          }
        }
      }
    }
  }

  ${goalCardItemFragment}
  ${eventCardItemFragment}
  ${cardTaskDetailFragment}
`;

export const workspaceDomainAndSubDomainsQuery = gql`
  query WorkspaceDomainAndSubDomainsQuery($id: ID!) {
    node(id: $id) {
      ... on Workspace {
        id

        dashboard {
          ...DashboardItemFragment

          dashboardFormat {
            id
            shortName

            parentDomains {
              nodes {
                ...ParentDomainMinimal

                subDomains {
                  nodes {
                    ...SubDomainMinimal
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${dashboardItemFragment}
  ${parentDomainMinimalFragment}
  ${subDomainMinimalFragment}
`;

export const workspacesQuery = gql`
  query WorkspacesQuery {
    workspaces {
      edges {
        node {
          id
          ...WorkspaceItemFragment
          ...WorkspaceViewerCanFragment

          dashboard {
            id
            title
            dashboardFormat {
              id
              shortName
            }
          }

          goalCards {
            activeCardCount
            nodes {
              id
              title
            }
          }

          eventCards {
            activeCardCount
            nodes {
              id
              title
            }
          }
        }
      }
    }
  }
  ${workspaceItemFragment}
  ${workspaceViewerCanFragment}
`;
